'use client'

import { useContext } from "react";
import FloatDialog from "./_floatDialog";
import ShareSheet from "../etc/web_share";
import { LiveStreamContext } from "@/app/livebroadcast/_config";
import { useTranslations } from "next-intl";

export default function FloatWebShare() {
    const { shareInfo, openWebShare, setOpenWebShare } = useContext(LiveStreamContext)

    const t = useTranslations("Text")

    return (
        <FloatDialog
            show={openWebShare}
            setShow={setOpenWebShare}
            className="web-share" >

            <FloatDialog.Head>{t("중계화면 공유하기")}</FloatDialog.Head>
            <FloatDialog.Body>
                <ShareSheet 
                    url={shareInfo.url} 
                    title={shareInfo.title} 
                    description={shareInfo.description} 
                    imageUrl={shareInfo.imageUrl} 
                    />
            </FloatDialog.Body>
        </FloatDialog>
    )
}